export function replaceMediaLinksInRichText(html: string): string {
  const GRAPHQL_URL = process.env.GRAPHQL_URL?.replace("/graphql", "")
  // Replace href="/media/..." with href="GRAPHQL_URL/media/..."
  return html
    .replace(/href="\/media\//g, `href="${GRAPHQL_URL}/media/`)
    ?.replace(/src="\/media\//g, `src="${GRAPHQL_URL}/media/`)
    ?.replace(/srcset="\/media\//g, `srcset="${GRAPHQL_URL}/media/`)
}
